module.exports = __webpack_public_path__ + "static/img/jinbi.375946c4.png";